import styled from 'styled-components';

export const OverviewModalWrap = styled.div`
	.ant-modal-content {
		height: 100%;
		.ant-modal-body {
			height: 90%;
		}
	}
	& iframe {
		width: 100%;
		height: 90%;
		overflow: auto;
		display: block;
		box-shadow: none;
		border: none;
	}

	& .ant-modal-body {
		overflow: auto;
	}
`;

export const ProjectRemoveNameSpan = styled.span`
	color: #de350a;
	margin-left: 6px;
`;
